import { computed, ref } from 'vue';
import { useUISettings } from './useUISettings';

export const WORKSPACE_MODES = ['hub', 'sidebar', 'focus'];
export const orderWorkspaceItems = (items, order = []) => {
  const positions = new Map(
    (Array.isArray(order) ? order : []).map((id, index) => [id, index])
  );
  return [...items].sort(
    (a, b) => (positions.get(a.id) ?? 9999) - (positions.get(b.id) ?? 9999)
  );
};

export function useWorkspaceNavigation() {
  const { uiSettings, updateUISettings } = useUISettings();
  const saving = ref(false);
  const failed = ref(false);
  const mode = computed(() => {
    const saved = uiSettings.value.workspace_v2_navigation;
    return WORKSPACE_MODES.includes(saved) ? saved : 'hub';
  });
  const order = computed(() => uiSettings.value.workspace_v2_world_order || []);
  const save = async patch => {
    if (saving.value) return false;
    saving.value = true;
    failed.value = false;
    try {
      const result = await updateUISettings(patch);
      failed.value = result === false;
      return result;
    } finally {
      saving.value = false;
    }
  };
  const setMode = value =>
    WORKSPACE_MODES.includes(value) && save({ workspace_v2_navigation: value });
  const setOrder = value => save({ workspace_v2_world_order: value });
  const setWorldVisible = (id, visible) => {
    const hidden = new Set(uiSettings.value.sidebar_hidden_worlds || []);
    if (visible) hidden.delete(id);
    else hidden.add(id);
    return save({ sidebar_hidden_worlds: [...hidden] });
  };
  const reset = () =>
    save({
      workspace_v2_navigation: 'hub',
      workspace_v2_world_order: [],
      sidebar_hidden_worlds: [],
    });
  return {
    mode,
    order,
    saving,
    failed,
    setMode,
    setOrder,
    setWorldVisible,
    reset,
  };
}
